import { render, staticRenderFns } from "./activityAuditDetail.vue?vue&type=template&id=bbe68554&scoped=true"
import script from "./activityAuditDetail.vue?vue&type=script&lang=js"
export * from "./activityAuditDetail.vue?vue&type=script&lang=js"
import style0 from "./activityAuditDetail.vue?vue&type=style&index=0&id=bbe68554&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe68554",
  null
  
)

export default component.exports